import { Divider, Fab, FormControlLabel, IconButton, MenuItem, Tooltip } from "@mui/material";
import { Add as AddIcon, ContentCopy as ContentCopyIcon, Edit as EditIcon, Delete as DeleteIcon, MoreHoriz as MoreHorizIcon, Visibility as VisibilityIcon } from "@mui/icons-material";
import LoaderSwitch from "components/Loaders/LoaderSwitch";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";
import Duplicate from "./Duplicate";
import { Android12Switch } from "components/Styled";

export function ActionsDialogPage({ open, close, instance, reportAction, extraData = {} }) {
  return (<>
    <Add
      open={open === 1}
      close={close}
      reportAction={reportAction}
      extraData={extraData} />
    <Edit
      open={open === 2}
      close={close}
      instance={instance}
      reportAction={reportAction}
      extraData={extraData} />
    <Remove
      open={open === 3}
      close={close}
      instance={instance}
      reportAction={reportAction} />
    <Duplicate
      open={open === 5}
      close={close}
      instance={instance}
      reportAction={reportAction} />
  </>)
}

export function ActionFabButtonAdd({ t, action }) {
  return (
    <span className="fab_add">
      <Tooltip title={t("menu_page_add_button_text")}>
        <Fab color="primary" onClick={action}> <AddIcon /></Fab>
      </Tooltip>
    </span>
  )
}

export function ActionsMenuPage({ t, action }) {
  // 2: edit, 3: delete
  return (<>
    <MenuItem /* onClick={() => action(4)} */ disableRipple>
      <VisibilityIcon /> {t("menu_page_show_menu_button_text")}
    </MenuItem>
    <MenuItem onClick={() => action(2)} disableRipple>
      <EditIcon /> {t("menu_page_edit_button_text")}
    </MenuItem>
    <MenuItem onClick={() => { action(5) }} disableRipple>
      <ContentCopyIcon /> {t('button_text_duplicate')}
    </MenuItem>
    <Divider />
    <MenuItem onClick={() => action(3)} disableRipple>
      <DeleteIcon /> {t("menu_page_delete_button_text")}
    </MenuItem>
  </>)
}

export function ActionsMUIRowRender({ value, data, open, actionClickMenu, loadingUpdateActive, itemId, getActive, actionUpdateActive }) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <IconButton
        sx={{ marginRight: 1.5 }}
        id="demo-customized-button"
        aria-haspopup="true"
        variant="contained"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={(event) => actionClickMenu(event, value)}>
        <MoreHorizIcon />
      </IconButton>
      {(loadingUpdateActive && itemId === value) ?
        <LoaderSwitch on={getActive(value, data)} /> :
        <FormControlLabel style={{ marginRight: 4 }}
          control={
            <Android12Switch checked={getActive(value, data)}
              disabled={(loadingUpdateActive && itemId === value)}
              onClick={() => actionUpdateActive(value)} />
          } />
      }
    </div>
  )
}